import '@ezugi/polyfills.js';

import { Fragment } from 'react';
import { createRoot } from 'react-dom/client';
import { useSelector } from 'react-redux';

import { createGame } from '@ezugi/bootstrap';
import GameShell from '@ezugi/bootstrap/src/GameShell';
import Preloader from '@ezugi/bootstrap/src/components/Preloader';
import { isGameStartedSelector } from '@ezugi/bootstrap/src/store/selectors';

import { GameArea } from './config';
import localeGroups from './localeGroups.json';
import {
  backAndLayEpics,
  betsEpic,
  betsReducer,
  cardsEpic,
  cardsReducer,
  keypadReducer,
  myBetsEpic,
  payoutsEpic,
  socketEpic,
  statisticsReducer,
} from './store';
import handleError from './store/epics/socket/handleError';
import handleOperatorError from './store/epics/socket/handleOperatorError';
import { isBackAndLayOnURL } from './utils';

const { store } = createGame({
  localeGroups,
  store: {
    epics: [ socketEpic, cardsEpic ].concat(
      isBackAndLayOnURL
        ? [ backAndLayEpics ]
        : [ betsEpic, payoutsEpic, myBetsEpic ]
    ),
    reducers: {
      cards: cardsReducer,
      bets: betsReducer,
      statistics: statisticsReducer,
      ...(isBackAndLayOnURL
        ? {
          keypad: keypadReducer,
        }
        : {}),
    },
    handleOperatorError,
    handleError,
  },
});

const OneDayTeenPatti = () => {
  const isGameStarted = useSelector(isGameStartedSelector);

  return (
    <Fragment>
      <GameArea />
      {isGameStarted ? null : <Preloader />}
    </Fragment>
  );
};

const rootElement = document.getElementById('root') as HTMLDivElement;
const root = createRoot(rootElement);

root.render(
  <GameShell store={store}>
    <OneDayTeenPatti />
  </GameShell>
);
